export default __webpack_public_path__ + "static/media/push-pin.b4e12420.png";